/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Phone_DescInputs */

const tr_landing_community_tile_phone_desc = /** @type {(inputs: Landing_Community_Tile_Phone_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonu sesli asistanımız karşılar ve talebinizi destek ekibimize kayıt olarak iletir.`)
};

const en_landing_community_tile_phone_desc = /** @type {(inputs: Landing_Community_Tile_Phone_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our voice assistant answers the phone and passes your request to our support team as a ticket.`)
};

const de_landing_community_tile_phone_desc = /** @type {(inputs: Landing_Community_Tile_Phone_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Am Telefon meldet sich unser Sprachassistent und gibt Ihr Anliegen als Ticket an unser Support-Team weiter.`)
};

const ru_landing_community_tile_phone_desc = /** @type {(inputs: Landing_Community_Tile_Phone_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`На звонок отвечает наш голосовой ассистент и передаёт ваш запрос команде поддержки в виде заявки.`)
};

/**
* | output |
* | --- |
* | "Our voice assistant answers the phone and passes your request to our support team as a ticket." |
*
* @param {Landing_Community_Tile_Phone_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_phone_desc = /** @type {((inputs?: Landing_Community_Tile_Phone_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Phone_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_phone_desc(inputs)
	if (locale === "de") return de_landing_community_tile_phone_desc(inputs)
	if (locale === "ru") return ru_landing_community_tile_phone_desc(inputs)
	return tr_landing_community_tile_phone_desc(inputs)
});